export default "__VITE_ASSET__rrLW6G0S__"